import * as React from "react";

export function useQuickJournalDuneAnimationPause(
    isClosingQuickJournal: boolean
): boolean {
    const [isDocumentHidden, setIsDocumentHidden] = React.useState(
        () =>
            typeof document !== "undefined" &&
            document.visibilityState === "hidden"
    );

    React.useEffect(() => {
        const handleVisibilityChange = () => {
            setIsDocumentHidden(document.visibilityState === "hidden");
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () =>
            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange
            );
    }, []);

    // QuickJournal intentionally keeps this textarea focused while open, so
    // focus cannot be used as a backdrop-animation pause signal.
    return isClosingQuickJournal || isDocumentHidden;
}
